export const nav = {
    permissao: 'hdocs.templates:ver',
    section: 'Configuracao',
    title: 'Templates',
    icon: 'article',
    route: '/templates',
    sequence: 13, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/templates',
        name: 'templates',
        component: () => import('./pages/TemplatesPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.templates:ver' },
    },
    // O editor e UMA pagina so para as duas formas ("nova" e um id): com o mesmo
    // registro de rota, salvar uma versao nova troca o endereco sem recriar a tela.
    {
        path: '/templates/:tipoId(\\d+)/:templateId(\\d+|nova)',
        name: 'template-editor',
        component: () => import('./pages/TemplateEditorPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'hdocs.templates:ver' },
    },
];
